import { render, staticRenderFns } from "./ActivationsRanking.vue?vue&type=template&id=154f2907&"
import script from "./ActivationsRanking.vue?vue&type=script&lang=js&"
export * from "./ActivationsRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports